import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../Shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/SubmitModal.css';
import success from '../../Assets/TruckVisits/Assets-Desktop/checked.svg';
import RespModal from '../Shared/RespModal';

function SuccessModal(props) {
    return(
        <RespModal hasOpen={props.hasOpen}  >
        <div className="modalsize" >
            <Image src={success} /><br /><br />
            <div id="modalcontainsuccess">
                 {props.children}
            </div>
            <Button
                id="resploginbutton"
                type="button"
                class="btn btn-dark"
                onClick={props.onCloseModal}
            >OK
        </Button><br /><br />
        </div>
    </RespModal>
    );
}
export default SuccessModal;